import React from 'react';
import { useIntl } from 'react-intl';
import AccionaBigButton from '../../../../components/AccionaBigButton';
import { useNavigate, useParams } from 'react-router-dom';

const Home = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <div className="row">
      <div className="col-xs-12 col-sm-6 col-md-6">
        <AccionaBigButton
          id="monitoring"
          icon="monitoring"
          onClick={() => {
            navigate(`/app/project/${id}/strength/hoodedControl/monitorings`);
          }}
          msg={intl.formatMessage({ id: `button.monitoring` })}
        />
      </div>
      <div className="col-xs-12 col-sm-6 col-md-6">
        <AccionaBigButton
          id="devices"
          icon="devices"
          onClick={() => {
            navigate(`/app/project/${id}/strength/hoodedControl/devices`);
          }}
          msg={intl.formatMessage({ id: `button.devices` })}
        />
      </div>
    </div>
  );
};

export default Home;
